// Custom product variant change code
(function () {
  let elementCurrentVariant = document.querySelectorAll('[name="id"]');
  Array.from(elementCurrentVariant).forEach((function (e) {
      e.removeAttribute('disabled');
    }
  ));
  const productOptions = document.getElementsByClassName('productOption');
  if (productOptions) {
    eventType = 'click',
    'dropdown' === variantStyle && (eventType = 'change'),
      Array.from(productOptions).forEach((function (productOption) {        
        productOption.addEventListener(eventType, (() => {
          const contentSection = productOption.closest('.yv_product_content_section');
          setTimeout((function () {
            let productOptionValue = productOption.value
              , productOptionName = productOption.getAttribute('name')
              , mainProductSection = contentSection.closest('.shopify-section');

            const productLoopVariants = Array.from(contentSection.querySelectorAll('.product-loop-variants'));
            const currentVariant = variantChange('dropdown' === variantStyle ? productLoopVariants.map((productOption => {
                return Array.from(productOption.querySelectorAll('select')).find((productOption => productOption)).value;
              }))
              : productLoopVariants.map((productOption => {
                return Array.from(productOption.querySelectorAll('input')).find((productOption => productOption.checked)).value;
              })), 'options', contentSection);
            
            // undefined if not found
            if (currentVariant) {
              
              mainProductSection.querySelector('.yv-product-detail-lease-price') && (mainProductSection.querySelector('.yv-product-detail-lease-price').style.display = "");
              mainProductSection.querySelector('.request-lease-block') && (mainProductSection.querySelector('.request-lease-block').style.display = "");

              // Update variant lease link
              const url = mainProductSection.querySelector('.request-lease-block > a').href;
              const href = new URL(url);
              href.searchParams.set('fiets', currentVariant.name + ' ' + currentVariant.title);
              href.searchParams.set('variant', currentVariant.id);
              mainProductSection.querySelector('.request-lease-block > a').href = href;

            } else {
              // hide lease price elements
              mainProductSection.querySelector('.yv-product-detail-lease-price') && (mainProductSection.querySelector('.yv-product-detail-lease-price').style.display = "none");
              mainProductSection.querySelector('.request-lease-block') && (mainProductSection.querySelector('.request-lease-block').style.display = "none");
            }
          }), 500);
        }));
      }));
  }
})();
